module.exports = __webpack_public_path__ + "static/media/availability-slide-5.e0a34b2b.jpg";